/* src/app/admin-dashboard/kampanje/kampanje-list.component.css */
.week-container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  padding: 16px;
  gap: 16px;
  overflow-x: auto;
}
.week-column {
  flex: 1;
  min-width: 200px;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.day-header {
  width: 100%;
  text-align: center;
  background-color: #f5f5f5;
  margin: 0 0 8px 0;
  padding: 8px 0;
  border-radius: 4px;
}
.subscription-card {
  width: 100%;
  margin-bottom: 16px;
  transition: box-shadow 0.3s ease;
}
.subscription-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.add-card {
  cursor: pointer;
  border: 2px dashed #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.add-card:hover {
  border-color: #3f51b5;
}
.add-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.add-card-content mat-icon {
  font-size: 48px;
  color: #3f51b5;
}
.add-card-content p {
  margin: 8px 0 0;
  font-size: 16px;
  font-weight: bold;
}
.no-data {
  font-style: italic;
  color: #888;
  text-align: center;
}
/*# sourceMappingURL=kampanje-list.component.css.map */
